import { ChangeEventWorkflow } from "src/generated/graphqlTypes";
import { GuidedWorkflow } from "src/routes/projects/change-events/guided/workflows/types";
import { addOrModifyOptionsWorkflow } from "./addOrModifyOptions/addOrModifyOptionsWorkflow";
import { applyInitialConfigurationWorkflow } from "./applyConfiguration/initial/applyInitialConfigurationWorkflow";
import { applyPartialConfigurationWorkflow } from "./applyConfiguration/partial/applyPartialConfigurationWorkflow";
import { configurationTrueUpWorkflow } from "./configurationTrueUp/configurationTrueUpWorkflow";
import { swapProductWorkflow } from "./swapProductCatalog/swapProductWorkflow";

/** A workflow that has a wizard to run, and whether it is released to everyone yet. */
type GuidedWorkflowEntry = { workflow: GuidedWorkflow<any>; released: boolean };

/**
 * Returns the workflow that drives `workflow`'s steps, or undefined if it has no wizard yet.
 *
 * The map lives in here rather than at module scope so the workflows are read when one is asked for, instead
 * of while this module is being evaluated. A workflow's own steps can reach back here through
 * `SwitchWorkflowButton` and `CreateGuidedChangeEventModal`, and entering that import cycle from a step would
 * otherwise run this module while `swapProductWorkflow` was still initialising, baking `undefined` into the
 * map for good. `GuidedWorkflow<any>` is the single, contained boundary where the per-workflow form shape is
 * erased; each definition keeps its concrete type, and the runner never inspects it.
 */
export function guidedWorkflowFor(workflow: ChangeEventWorkflow): GuidedWorkflowEntry | undefined {
  const guidedWorkflows: Record<ChangeEventWorkflow, GuidedWorkflowEntry | undefined> = {
    [ChangeEventWorkflow.SwapProduct]: { workflow: swapProductWorkflow, released: true },
    [ChangeEventWorkflow.ApplyInitialConfiguration]: { workflow: applyInitialConfigurationWorkflow, released: true },
    [ChangeEventWorkflow.ApplyPartialConfiguration]: { workflow: applyPartialConfigurationWorkflow, released: true },
    [ChangeEventWorkflow.AddOrModifyOptions]: { workflow: addOrModifyOptionsWorkflow, released: false },
    [ChangeEventWorkflow.ConfigurationTrueUp]: { workflow: configurationTrueUpWorkflow, released: false },
    [ChangeEventWorkflow.FullLineCustomOption]: undefined,
  };
  return guidedWorkflows[workflow];
}
